import React from "react";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./PromptModal.module.scss";
import ArrowDown from "../../assets/images/ic_arrowDown.svg";

interface PromptModalProps {
  open: boolean;
  onClose: () => void;
  anchored?: boolean;
  blobUrl?: string;
  fileName?: string;
  templateFileName?: string;
}

const defaultPromptUrl = `${import.meta.env.VITE_TEMPLATE_BLOB_URL}/prompt-templates/Press_Release_Brief_Template.docx?${import.meta.env.VITE_TEMPLATE_G42_FILES}`;
const defaultFileName = "Press_Release_Brief_Template.docx";

const PromptModal: React.FC<PromptModalProps> = ({
  open,
  onClose,
  anchored = false,
  blobUrl,
  fileName,
  templateFileName,
}) => {
  const handleDownload = () => {
    try {
      // Construct URL based on templateFileName or fallback to blobUrl or default
      const downloadUrl = templateFileName
        ? `${import.meta.env.VITE_TEMPLATE_BLOB_URL}/prompt-templates/${templateFileName}?${import.meta.env.VITE_TEMPLATE_G42_FILES}`
        : blobUrl || defaultPromptUrl;

      const downloadFileName =
        templateFileName ||
        (blobUrl
          ? decodeURIComponent(blobUrl.split("/").pop() || "")
          : defaultFileName);

      // Create a temporary anchor element to trigger download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = downloadFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Auto-close modal after download
      onClose();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className={`${styles.modalContainer} ${
          anchored ? styles.anchoredModal : styles.centeredModal
        }`}
      >
        <IconButton className={styles.closeIcon} onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <h4 className={styles.modalTitle}>Tip for better results</h4>
        <p className={styles.modalDescription}>
          Treat this agent as your PR team. Clear, detailed inputs in the press
          release brief will directly improve the quality and accuracy of the
          output.
        </p>
        <button className={styles.modalButton} onClick={handleDownload}>
          <span>Download Template</span>
          <img src={ArrowDown} alt="down arrow" className={styles.buttonIcon} />
        </button>
      </Box>
    </Modal>
  );
};

export default PromptModal;
